import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import Calendar from '../../../components/Calendar'
import useCalendar from '../hooks/useCalendar'
import dayjs from '../../../lib/dayjs'

const ArticlesCalendar = () => {
  const [range, setRange] = useState<{ start: Date; end: Date }>({
    start: dayjs().startOf('month').toDate(),
    end: dayjs().endOf('month').toDate()
  })

  const { events, loading, loadEvents } = useCalendar()

  useEffect(() => {
    loadEvents(range)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range])

  return (
    <Box
      sx={{
        height: '100%',
        width: {
          xs: 500, // theme.breakpoints.up('xs')
          sm: 500, // theme.breakpoints.up('sm')
          md: 660, // theme.breakpoints.up('md')
          lg: 960, // theme.breakpoints.up('lg')
          xl: 1300 // theme.breakpoints.up('xl')
        }
      }}
    >
      <Calendar loading={loading} events={events} onRangeChanged={setRange} />
    </Box>
  )
}

export default ArticlesCalendar
